module.exports = {"TXTWCL_Penalties":{"id":"TXTWCL_Penalties","defaultMessage":"Straffe"}}